
// console.log('cutOffTimes: ');
// console.log(cutOffTimes);

if (cutOffTimes && cutOffTimes.length > 0) {
  const currentPSTDateTime = () => {
    const currentTime = new Date();
    const pstDateString = currentTime.toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });

    return new Date(pstDateString);
  }

  const milisecondToText = (diff) => {

    let ms = diff % 1000;
    let ss = Math.floor(diff / 1000) % 60;
    let mm = Math.floor(diff / 1000 / 60) % 60;
    let hh = Math.floor(diff / 1000 / 60 / 60);

    return { hh, mm, ss }
  }

  const currentTime = currentPSTDateTime();
  // console.log('currentTime: ');
  // console.log(currentTime);

  const currentWeekDay = currentTime.getDay();
  const todaysCutOff = cutOffTimes.find((c) => currentWeekDay == c.day_of_week);

  const todaysCutOffIime = currentPSTDateTime();
  todaysCutOffIime.setHours(todaysCutOff.cut_off_time_hours);
  todaysCutOffIime.setMinutes(todaysCutOff.cut_off_time_minuts);

  const remainingCutoffTime = todaysCutOffIime.getTime() - currentTime.getTime();
  let remainingCutoffTimeText = '';

  let eddDays = 0;

  // Check if remainingCutoff time is over
  if (remainingCutoffTime > 0) {
    eddDays = todaysCutOff.days_to_fulfill_before_cutoff;

    remainingCutoffTimeText = milisecondToText(remainingCutoffTime);
  } else {
    const isWeekends = currentWeekDay == 5 || currentWeekDay == 6; // Friday or saterday
    // eddDays = todaysCutOff.days_to_fulfill_after_cutoff;
    
    // Note: days_to_fulfill_after_cutoff is excluding weekdend, But our addBusinessDays function also excluding weekends too so it's excluding twice, so this was going wrong.
    eddDays = isWeekends ? 0 : 1;


    // Get remaining cutoff time for next days cutoff time
    // Next day cutoff time
    todaysCutOffIime.setTime(todaysCutOffIime.getTime() + (24 * 60 * 60 * 1000 * todaysCutOff.days_to_fulfill_after_cutoff)); // Added 24 hours * next days to fulfill
    const remainingCutoffTime = todaysCutOffIime.getTime() - currentTime.getTime();
    remainingCutoffTimeText = milisecondToText(remainingCutoffTime);
  }

  // console.log(currentTime);
  // console.log(todaysCutOffIime);


  // // Check for BEFORE cutoff
  // if (currentTime.getTime() < todaysCutOffIime.getTime()) {
  //   // console.log('EDD: Before cutoff');

  //   eddDays = todaysCutOff.days_to_fulfill_before_cutoff;

  // } else { // AFTER cutoff
  //   // console.log('EDD: after cutoff');

  //   eddDays = todaysCutOff.days_to_fulfill_after_cutoff;
  // }

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  document.addEventListener('alpine:init', () => {
    Alpine.store('edd', {
      eddSettings,
      podSettings,
      podExists,
      eddDays,
      eddDateText: null,
      eddStyles,
      eddLabel,
      postalCode: null,
      newPostalCode: null,
      daysInTransit: null,
      remainingCutoffTimeText,
      isEditPostalCode: false,
      isLoading: true,

      init() {
        const cachedEddData = window.sessionStorage.getItem('LIF-PARAMS-edd-days-in-transit');
        if (cachedEddData) {
          // console.log('Found CachedEddData.');
          console.log('POD settings');
          console.log(this.podSettings);
          console.log(this.podExists);
          
          const { postalCode, days } = JSON.parse(cachedEddData);
          this.postalCode = postalCode;
          this.newPostalCode = postalCode;
          this.daysInTransit = days;
          this.isLoading = false;
        } else {
          // console.log('Not Found CachedEddData. Refetching...');

          // Get IP address info of customer
          fetch('https://ipinfo.io/?callback')
          .then(response => response.json())
          .then(response => {
            // console.log(response); 
            this.postalCode = response.postal;
            this.newPostalCode = response.postal;
            this.updateEddByPortalCode();
          })
          .catch((e) => console.error('Error while fetching ipinfo!'));
        }
      },
      updateEddByPortalCode() {
        if (!this.newPostalCode || this.newPostalCode == '') {
          return false;
        }

        // get edd days by postal code
        fetch('https://cron.loveinfaith.work/store-backend/edd/getEddByPostalCode?postal_code='+this.newPostalCode)
          .then(response => response.json())
          .then(response => {
            this.postalCode = this.newPostalCode;
            
            if (response.data && response.data.days_in_transit) {
              this.daysInTransit = parseInt(response.data.days_in_transit);
            } else {
              this.daysInTransit = null;
            }

            // Cache data to avoid refetch everytime
            const cacheData = {
              postalCode: this.newPostalCode,
              days: this.daysInTransit,
            };

            window.sessionStorage.setItem('LIF-PARAMS-edd-days-in-transit', JSON.stringify(cacheData));
            this.isLoading = false;
          })
      },
      editPostalCode() {
        this.newPostalCode = this.postalCode;
        this.isEditPostalCode = true;
      },
      updatePostalCode() {
        if (!this.newPostalCode || this.newPostalCode == '') {
          return false;
        }
        this.updateEddByPortalCode();
        this.isEditPostalCode = false;
      },
      addBusinessDays(daysToAdd) {
        const resultDate = currentPSTDateTime();
        let addedDays = 0;

        while (addedDays < daysToAdd) {
          resultDate.setDate(resultDate.getDate() + 1);
          const day = resultDate.getDay();
          if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
            addedDays++;
          }
        }

        return resultDate;
      },
      get eddDateText() {
        
        let totalEddDays = this.eddDays + this.daysInTransit;
        if(this.podExists == 'yes') {
          totalEddDays += Number(this.podSettings);
        }
        
        const eddDate = this.addBusinessDays(totalEddDays);

        /*
        const currentDate = currentPSTDateTime();

        // Check if fall in weekends
        if (totalEddDays >= 6 || (currentDate.getDay() + totalEddDays) >= 6) {
          // Add exclude weekend by adding two more days
          totalEddDays += 2;

          // Check for second weekends
          if (currentDate.getDay() + totalEddDays >= 13) {
            totalEddDays += 2;
          }
        }

        // console.log('Final Edd Date: ');
        // console.log(eddDate);

        const eddDate = currentPSTDateTime();
        eddDate.setDate(eddDate.getDate() + totalEddDays);
        */

        const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const weekDay = weekDays[eddDate.getDay()];
        const month = monthNames[eddDate.getMonth()];
        const date = eddDate.getDate();

        // this.eddDateText = eddDate.toISOString().split('T')[0];
        return `${weekDay}, ${month} ${date}`;
      },
      get hourText() {
        return this.remainingCutoffTimeText.hh > 1 ? 'hrs' : 'hr';
      },
      get minutText() {
        return this.remainingCutoffTimeText.mm > 1 ? 'mins' : 'min';
      },
      getOverSoldETA(dateText) {
        
        const currentDate = currentPSTDateTime();

        let eddDate = null
        if (dateText) {
          eddDate = new Date(dateText);
        }

        // IF oversold_po_eta IS NULL OR IF oversold_po_eta < TODAY()
        // Add +7 days to TODAY() and use that as the guaranteed ship date
        if (!eddDate ||  currentDate.toDateString() === eddDate.toDateString() || currentDate.getTime() > eddDate.getTime()) {
          currentDate.setDate(currentDate.getDate() + 7);
          eddDate = currentDate;
        }

        const weekDay = weekDays[eddDate.getDay()];
        const month = monthNames[eddDate.getMonth()];
        const date = eddDate.getDate();

        // this.eddDateText = eddDate.toISOString().split('T')[0];
        return `${weekDay}, ${month} ${date}`;
      }
    });
  });
}